// extracted by mini-css-extract-plugin
export var chevronIcon = "_bx-2";
export var teamName = "_bx-1";
export var teamSwitcherButton = "_bx-0";